<template>
  <crm-dialog
    :visible.sync="visible"
    :append-to-body="true"
    :close-on-click-modal="false"
    :before-close="handleClose"
    title="查重"
    custom-class="no-padding-dialog"
    width="870px">
    <span slot="title" class="el-dialog__title">查重</span>
      <!-- <i v-if="helpObj" class="wk wk-icon-fill-help wk-help-tips" :data-type="helpObj.type" :data-id="helpObj.id"/> -->
    <div
      v-loading="loading"
      :class="{ 'show-table': showTable }"
      class="duplicate-check">
      <div class="searchInputWrap">
        <el-input
          v-model="searchContent"
          class="search-input"
          @keyup.enter.native="getList">
          <crm-select
            slot="prepend"
            v-model="typeSelect">
            <el-option
              label="按客户名称"
              value="name"/>
            <el-option
              label="按客户手机号"
              value="phone"/>
            <el-option
              label="按联系人手机号"
              value="contacts"/>
          </crm-select>
          <el-button
            slot="append"
            type="primary"
            icon="wk wk-search"
            @click.native="getList">查重</el-button>
        </el-input>
        <el-checkbox v-model="isMultiTenant" class="crossTenantCheckbox">跨业务线查重</el-checkbox>
      </div>

      <el-table
        v-if="showTable"
        :data="tableData"
        :cell-class-name="cellClassName"
        class="duplicate-check__content"
        border
        height="380"
        style="width: 100%;"
        @sort-change="sortChange"
        @row-click="handleRowClick">
        <el-table-column
          v-for="(item, index) in fieldList"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.width"
          :sortable="item.sortable ? item.prop : false"
          :fixed="item.fixed"
          show-overflow-tooltip>
          <template slot-scope="{ row }">
            <template v-if="item.prop === 'customerName'">
              <span
                class="duplicate-custom-name"
                @click="$emit('detail', { id: row.id, type: 'customer' })">{{ row.customerName }}</span>
            </template>
            <template v-else-if="item.prop === 'teamMembers'">
              {{ row.teamMembers ? row.teamMembers.join('、') : '-' }}
            </template>
            <template v-else>
              {{ row[item.prop] }}
            </template>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          width="110px"
          label="操作">
          <template slot-scope="scope">
            <el-button
              type="primary-text"
              style="padding: 0;"
              :disabled="!scope.row.poolAuthList || !scope.row.poolAuthList.receive"
              @click="handleClick('receive', scope.row)">领取</el-button>
            <el-button
              type="primary-text"
              style="padding: 0;"
              :disabled="!scope.row.poolAuthList ||!scope.row.poolAuthList.distribute"
              @click="handleClick('distribute', scope.row)">分配</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div
        v-if="showTable"
        class="duplicate-check__footer">注：查重结果最多显示10条，如不完整，请完善查重条件</div>

      <c-r-m-full-screen-detail
        :id="relationId"
        :visible.sync="showFullDetail"
        :crm-type="relationCrmType"
        :pool-id="poolId"
        @handle="getList"/>

      <alloc-handle
        :pool-id="poolId"
        :selection-list="[relationData]"
        :dialog-visible.sync="allocDialogShow"
        :crm-type="crmType"
        @handle="getList"/>
    </div>
  </crm-dialog>
</template>

<script>
import {
  crmCustomerDataCheckAPI,
  crmCustomerReceiveAPI
} from '@/api/crm/customer';

import {
  crmContactsReceiveAPI,
  crmContactsDataCheckAPI
} from '@/api/crm/contacts';

import AllocHandle from '../SelectionHandle/AllocHandle'; // 公海分配操作

import crmTypeModel from '@/wkcrmViews/crm/model/crmTypeModel';

export default {
  name: 'DuplicateCheck',
  components: {
    AllocHandle,
    CRMFullScreenDetail: () =>
      import('@/components/CRMFullScreenDetail')
  },
  props: {
    crmType: String,
    visible: {
      type: Boolean,
      default: false
    },
    defaultValue: String
  },
  data() {
    return {
      loading: false,
      typeSelect: 'name',
      searchContent: '',
      isMultiTenant: true,
      tableData: null,
      sortData: {}, // 字段排序

      showFullDetail: false, // 查看相关客户管理详情
      relationId: '', // 相关ID参数
      relationData: {}, // 关联数据
      poolId: '', // 公海Id
      relationCrmType: '', // 相关类型
      allocDialogShow: false //  分配弹窗
    };
  },
  computed: {
    showTable() {
      return this.tableData;
    },

    isCustomerFilter() {
      return this.typeSelect == 'name';
    },

    isContactsFilter() {
      return this.typeSelect == 'contacts';
    },

    // 客户名称、创建时间、负责人、最后跟进时间、操作
    fieldList() {
      if (this.isCustomerFilter) {
        return [{
          prop: 'customerName',
          label: '客户名称',
          width: 160,
          sortable: true,
          fixed: 'left'
        }, {
          prop: 'tenantName',
          label: '所在业务线',
          width: 110,
          sortable: true,
          fixed: 'left'
        }, {
          prop: 'ownerUserName',
          label: '负责人',
          width: 100
        }, {
          prop: 'lastFollowTime',
          label: '最后跟进时间',
          width: 130,
          sortable: true
        }, {
          prop: 'teamMembers',
          label: '相关团队',
          width: 100
        }, {
          prop: 'createTime',
          label: '创建时间',
          width: 130
        }, {
          prop: 'dealStatusName',
          label: '成交状态',
          width: 110,
          sortable: true,
          fixed: 'right'
        }];
      }
      if (this.isContactsFilter) {
        return [{
          prop: 'contactsName',
          label: '联系人',
          width: 160
        }, {
          prop: 'name',
          label: '客户名称',
          width: 200
        }, {
          prop: 'mobile',
          label: '联系人手机号',
          width: 160
        }, {
          prop: 'ownerUserName',
          label: '联系人负责人',
          width: 100
        }, {
          prop: 'createTime',
          label: '创建时间',
          width: 160
        }, {
          prop: 'lastTime',
          label: '最后跟进时间',
          width: 160
        }, {
          prop: 'module',
          label: '模块',
          width: 100
        }];
      }

      return [{
        prop: 'mobile',
        label: '手机号/电话',
        width: 160
      }, {
        prop: 'contactsName',
        label: '联系人',
        width: 160
      }, {
        prop: 'name',
        label: '客户名称',
        width: 200
      }, {
        prop: 'ownerUserName',
        label: '负责人',
        width: 100
      }, {
        prop: 'module',
        label: '模块',
        width: 100
      }];
    },

    // 帮助信息
    helpObj() {
      return {
        leads: {
          type: '7',
          id: '77'
        }, customer: {
          type: '8',
          id: '78'
        }, contacts: {
          type: '9',
          id: '79'
        }
      }[this.crmType] || null;
    }
  },
  watch: {
    typeSelect() {
      this.searchContent = '';
      this.tableData = null;
    },
    'defaultValue': {
      handler(val) {
        if (val) {
          this.searchContent = val;
          this.getList();
        }
      },
      immediate: true
    }
  },
  mounted() {},
  methods: {
    handleClose() {
      this.$emit('update:visible', false);
      this.resetData();
    },

    resetData() {
      this.typeSelect = 'name';
      this.searchContent = '';
      this.tableData = null;
      this.sortData = {};
    },

    /**
     * 字段排序
     */
    sortChange(column, prop, order) {
      this.sortData = column;
      this.getList();
    },

    getList() {
      if (!this.searchContent) {
        return;
      }
      const { isContactsFilter } = this;

      const params = {
        isMultiTenant: this.isMultiTenant
      };
      if (isContactsFilter) {
        params['phone'] = this.searchContent;
      } else {
        params[this.typeSelect] = this.searchContent;
      }
      if (this.sortData.order) {
        params.sortField = this.sortData.prop;
        params.order = this.sortData.order == 'ascending' ? 2 : 1;
      }
      this.loading = true;
      let API = null;
      if (isContactsFilter) {
        API = crmContactsDataCheckAPI;
      } else {
        API = crmCustomerDataCheckAPI;
      }
      API(params).then(res => {
        this.loading = false;
        const list = res.data || [];
        this.tableData = list.map(item => {
          item.module = crmTypeModel.convertTypeToName(item.type);
          if (item.poolName) {
            item.module = `${item.module}（${item.poolName}）`;
          }
          // 是手机号
          if (!this.isCustomerFilter) {
            item.mobile = this.searchContent;
            if (item.type == crmTypeModel.contacts || item.type == crmTypeModel.contactsPool) {
              item.contactsName = item.name;
              item.contactsId = item.id;

              item.name = item.customerName;
              item.id = item.customerId;

              // name 字段对应的点击类型 以type为准，所以将type校准为客户
              // 联系人详情 已 contactsId 为准
              item.type = crmTypeModel.customer;
            }
          }

          return item;
        });
      }).catch(() => {
        this.loading = false;
      });
    },

    /**
     * 列表点击
     */
    handleRowClick(row, column, event) {
      if (column && column.property == 'name' && row.id) {
        this.relationId = row.id;
        if (row.poolAuthList) {
          this.poolId = row.poolAuthList.poolId;
        } else {
          this.poolId = '';
        }
        const key = crmTypeModel.convertTypeToKey(row.type);
        this.relationCrmType = key == 'pool' ? 'customer' : key;
        this.showFullDetail = true;
      } else if (column.property == 'contactsName' && row.contactsId) {
        this.relationId = row.contactsId;
        if (row.poolAuthList) {
          this.poolId = row.poolAuthList.poolId;
        } else {
          this.poolId = '';
        }
        this.relationCrmType = 'contacts';
        this.showFullDetail = true;
      }
    },

    /**
     * 通过回调控制class
     */
    cellClassName({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'name' || column.property === 'contactsName') {
        return 'can-visit--underline';
      } else {
        return '';
      }
    },

    handleClick(type, data) {
      const { isContactsFilter } = this;
      if (type === 'receive') {
        this.$confirm(`确定要领取该${isContactsFilter ? '联系人' : '客户'}吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let API = null;
            if (isContactsFilter) {
              API = crmContactsReceiveAPI;
            } else {
              API = crmCustomerReceiveAPI;
            }
            API({
              ids: [isContactsFilter ? data.contactsId : data.id],
              poolId: data.poolAuthList.poolId
            })
              .then(res => {
                this.$crmMessage.success('操作成功');
                this.getList();
              })
              .catch(() => {});
          })
          .catch(() => {});
      } else {
        data['customerId'] = data.id;
        this.relationData = data;
        this.allocDialogShow = true;
      }
    }
  }
};
</script>

<style scoped lang="scss">
/deep/.el-dialog {
  border-radius: 2px;
  .el-dialog__header {
    height: auto;
    line-height: 24px;
    padding: 15px 20px 10px;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
}
.duplicate-check {
  position: relative;
  padding: 20px;
  padding-bottom: 40px;

  &__content {
    margin-top: 15px;
  }

  &__footer {
    margin-top: 8px;
  }

  .duplicate-custom-name {
    color: #0052cc;
    cursor: pointer;

    &:hover {
      text-underline-position: below;
    }
  }
}

.searchInputWrap {
  display: flex;
  align-items: center;

  .search-input {
    flex: auto;
    width: 0;
  }
}

.crossTenantCheckbox {
  margin-left: 12px;
}

.duplicate-check.show-table {
  padding-bottom: 20px;
}

.el-input {
  /deep/ .el-select .el-input {
    width: 140px;

    /deep/ i {
      font-weight: bold;
    }
  }

  /deep/ .el-input-group__append {
    color: white;
    background-color: $--color-primary;
    border-color: $--color-primary;

    .el-button {
      /deep/ i {
        margin-right: 5px;
        font-size: 14px;
      }
    }
  }
}
</style>
